import React from 'react';

const LinkedIn = () => (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#0F161E"
        fillRule="evenodd"
        d="M4.182 2A2.182 2.182 0 002 4.182v15.636C2 21.023 2.977 22 4.182 22h15.636A2.182 2.182 0 0022 19.818V4.182A2.182 2.182 0 0019.818 2H4.182zm.898 7.598v9.545H8.05V9.598H5.08zm-.236-3.022a1.72 1.72 0 003.437 0c0-.947-.772-1.719-1.718-1.719a1.72 1.72 0 00-1.72 1.719zm11.348 12.567h2.964V13.91c0-2.572-.558-4.55-3.558-4.55-1.442 0-2.41.79-2.808 1.54h-.04V9.599H9.906v9.545h2.965V14.42c0-1.246.236-2.451 1.78-2.451 1.519 0 1.541 1.424 1.541 2.531v4.643z"
        clipRule="evenodd"
       />
    </svg>
);

export default LinkedIn;
